export default "__VITE_ASSET__GCKGCh5Y__"